module.exports = __webpack_public_path__ + "img/finlast-gif.55bfd88d.gif";